import { render } from "./BotaoAdicionarItem.vue?vue&type=template&id=64c07c05&scoped=true"
import script from "./BotaoAdicionarItem.vue?vue&type=script&lang=js"
export * from "./BotaoAdicionarItem.vue?vue&type=script&lang=js"

import "./BotaoAdicionarItem.vue?vue&type=style&index=0&id=64c07c05&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c07c05"]])

export default __exports__